import Vue from 'vue';
import axios from 'axios';
import wx from 'weixin-js-sdk';
async function getsharetoken() { // 获取分享所需token
  let res = await axios.get("https://api.lotusdata.com/v1/buser/token", {params: { username: "system@akso.com", password: "123123", refreshtoken: "0"}})
  let { code, token } = res.data
  let Token = code === '0' ? `JWT ${token}` : ''
  return Token
}
async function getWeChatSdk(href, token) {
  let url = `https://api.lotusdata.com/v1/wx/jsconfig`
  let params = {
    url: href
  }
  let res = await axios.post(url, {}, {params, headers: { Authorization: token }})
  return res.data
}
function wxconfig (data, wechat) {
  wx.config({
    debug: false, // 打开调试
    appId: data.AppID, // 分享的id
    timestamp: Number(data.TimeStamp), // 必填，生成签名的时间戳
    nonceStr: data.NonceStr, // 必填，生成签名的随机串
    signature: data.Signature, // 必填，签名，见附录1
    jsApiList: [
      "updateTimelineShareData",
      "updateAppMessageShareData"
    ]
  });
  wx.ready(() => {// 微信SDK初始化成功后执行的回调函数
    if (wx.updateAppMessageShareData) {
      //分享到朋友圈  需在用户可能点击分享按钮前就先调用
      wx.updateTimelineShareData({
        title: wechat.title || `陕西省保健学会`, // 分享时的标题
        desc: wechat.desc || '  ', // 分享描述
        link: wechat.link, // 分享时的链接
        imgUrl: wechat.imgUrl, // 分享图标
        success: function () {// 设置成功
          console.log("分享到朋友圈成功");
        },
        cancel: function () {// 取消设置
          console.log("分享到朋友圈取消");
        },
        fail: function () {
          console.log("分享朋友圈失败");
        },
      });
      // 分享给朋友的设置
      wx.updateAppMessageShareData({
        title: wechat.title, // 分享时的标题
        desc: wechat.desc || '   ', // 分享描述
        link: wechat.link, // 分享时的链接
        imgUrl: wechat.imgUrl, // 分享图标
        success: function () {// 设置成功
          console.log("分享给朋友成功");
        },
        cancel: function () { // 设置失败
          console.log("分享给朋友失败");
        },
        fail: function () {
          console.log("分享朋友圈失败");
        },
      });
    } else {
      wx.onMenuShareAppMessage({
        title: wechat.title, // 分享时的标题
        desc: wechat.desc || '  ', // 分享描述
        link: wechat.link, // 分享时的链接
        imgUrl: wechat.imgUrl, // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
        }
      })
    }

  });
  wx.error((res) => {// 微信SDK初始化失败后的回调函数
    console.error('微信JS-SDK初始化失败：', res)
  });

}
// 网页分享到微信
Vue.prototype.$wxShare = async(wechat)=>{
  let Token = await getsharetoken()
  if(Token) {
    let res = await getWeChatSdk(wechat.link, Token)
    if (res.code === '0') {
      let data = res.data
      wxconfig(data, wechat)
    }
  }

}





// WEBPACK FOOTER //
// ./src/assets/js/common.js